<template>
    <div class="main_container">
        <div class="search-box" id="searchBox">
            <div @click="showMore" class="showMoreBtn">
                <i class="iconfont icon-you" v-bind:class="{ 'icon-shang': isShowMore }"></i>
                <span>{{ $t('message.Search') }}</span>
            </div>
            <div v-show="isShowMore">
                <el-form :label-width="labelW" :model="ruleForm" ref="ruleForm">
                    <el-form-item :label="$t('message.BusinessName')" prop="Name">
                        <el-input placeholder=" " v-model="ruleForm.Name"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('message.VATNo')" prop="VATNo">
                        <el-input placeholder=" " v-model="ruleForm.VATNo"></el-input>
                    </el-form-item>
                    <div class="button-line">
                        <el-form-item>
                            <el-tooltip :content="$t('message.Search')" class="item" effect="dark" placement="top">
                                <el-button
                                    @click="submitForm('ruleForm')"
                                    class="icon iconfont icon-sousuo"
                                    type="primary"
                                ></el-button>
                            </el-tooltip>
                            <el-tooltip :content="$t('message.Reset')" class="item" effect="dark" placement="top">
                                <el-button
                                    @click="resetForm('ruleForm')"
                                    class="icon iconfont icon-zhongzhi"
                                ></el-button>
                            </el-tooltip>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="table_container" v-loading="isLoading">
            <!-- <el-button-group>
                <el-tooltip :content="$t('message.Import')" class="item" effect="dark" placement="top">
                    <el-button @click="handleAdd" class="el-icon-upload2" type="primary"></el-button>
                </el-tooltip>
                <el-tooltip :content="$t('message.Export')" class="item" effect="dark" placement="top">
                    <el-button @click="handleAdd" class="el-icon-download" type="primary"></el-button>
                </el-tooltip>
            </el-button-group> -->
            <excelImport ref='importExport' :departmentData="importExportData" @event1="excelChildChange($event)"></excelImport>
            <el-button-group style="padding-left: 5px">
                <el-tooltip
                    effect="dark"
                    class="item"
                    :content="$t('message.Export')"
                    placement="top"
                >
                    <el-button
                    type="primary"
                    size="mini"
                    class="iconfont icon-xiazai-kong1"
                    @click="exportData"
                    ></el-button>
                </el-tooltip>
            </el-button-group>
            <el-table
                :data="tableData"
                :header-cell-style="{ 'background-color': '#f8f8f9', color: '#262626' }"
                :height="tableHeight"
                :max-height="tableHeight"
                :row-key="row => row.index"
                class="table_list table_border"
                ref="multipleTable"
                stripe
            >
                <el-table-column :label="$t('message.BusinessName')" :min-width="150" prop="Name"></el-table-column>
                <el-table-column :label="$t('message.VATNo')" :min-width="150" prop="VATNo"></el-table-column>
                <el-table-column
                    :label="$t('message.CreateTime')"
                    :min-width="250"
                    :show-overflow-tooltip="true"
                    prop="CreateTime"
                ></el-table-column>
                <el-table-column
                    :label="$t('message.UpdateTime')"
                    :min-width="250"
                    :show-overflow-tooltip="true"
                    prop="UpdateTime"
                ></el-table-column>
                <el-table-column :label="$t('message.Operating')" width="80">
                    <template slot-scope="scope">
                        <el-tooltip :content="$t('message.Delete')" class="item" effect="dark" placement="top">
                            <el-button
                                @click="handleDelete(scope.row.Id)"
                                class="hoverBtn iconfont icon-shanchu-kong"
                            ></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="Pagination">
                <el-pagination
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 30, 40]"
                    :total="count"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                ></el-pagination>
            </div>
        </div>
        <!--导入预览-->
        <el-dialog
            :title="$t('message.ImportPreview')"
            :visible.sync="importDialogVisibleView"
            class="form_dialog"
            v-if="importDialogVisibleView"
            :append-to-body="true"
            :close-on-click-modal="false"
            @close="handleClose"
            width="90%"
        >
            <ImportPreview
                :PreviewData="excelListView"
                :PreviewLabelData="labelImportTitle"
                @excelAction="excelAction"
            ></ImportPreview>
        </el-dialog>
    </div>
</template>

<script>
import excelImport from '@/views/components/excelImport';
import ImportPreview from '@/views/components/ImportPreview';
import { GetBlacklistList, DelBlacklist, GetTemplateFile, ImportPreviewCompensation, ExportPreviewCompensation, ImportBlacklist } from '../api/apiBlacklist';
import { removeStore, getLocal } from '../config/mUtils';

export default {
    name: 'merchantBlacklist',
    components: {
        ImportPreview,
        excelImport
    },
    data() {
        return {
            importDialogVisibleView: false,
            labelW: 0 + 'px',
            isShowMore: false,
            activeName: 'first',
            ruleForm: {
                Name: '',
                VATNo: ''
            },
            tableHeight: 0,
            isLoading: false,
            tableData: [],
            offset: 1,
            limit: 10,
            count: 0,
            currentPage: 1,
            // 导入参数
            /*向子组件传递值*/
            importExportData: {
                import: {
                    apiUrl: ImportPreviewCompensation,
                    fileType: 'xls',
                    show: true,
                    code: this.$t('message.Import')
                },
                export: {
                    apiUrl: GetTemplateFile,
                    fileType: 'xls',
                    show: true,
                    code: this.$t('message.modelDownload')
                }
            },
            importDialogVisibleView: false,
            excelListView: [],
            //导入预览表头定义
            labelImportTitle: [
                { label: this.$t('message.BusinessName'), prop: 'Name', width: '150' },
                { label: this.$t('message.VATNo'), prop: 'VATNo', width: '150' },
                { label: '错误提示', prop: 'ErrorMsg', width: '200' }
            ]
        };
    },
    created() {
        this.getLanguageResourceForPage();
        this.watchHeight();
        this.initData();
        this.resetLabelWidth();
        removeStore('OCRData');
        removeStore('changedInvoiceIndexData');
    },
    mounted() {
        setTimeout(() => {
            let widowHeight = document.documentElement.clientHeight - 275;
            let h = document.getElementById('searchBox').clientHeight;
            this.tableHeight = widowHeight - h;
        }, 1);
    },
    computed: {
        canResetH() {
            return this.isShowMore;
        },
        langChange() {
            return this.$i18n.locale;
        }
    },
    watch: {
        canResetH() {
            setTimeout(() => {
                let widowHeight = document.documentElement.clientHeight - 275;
                let h = document.getElementById('searchBox').clientHeight;
                this.tableHeight = widowHeight - h;
            }, 1);
        },
        langChange(val) {
            if (val) {
                this.isShowMore = false;
                this.resetLabelWidth();
                setTimeout(() => {
                    let widowHeight = document.documentElement.clientHeight - 275;
                    let h = document.getElementById('searchBox').clientHeight;
                    this.tableHeight = widowHeight - h;
                }, 1);
            }
        }
    },
    methods: {
        watchHeight() {
            setTimeout(() => {
                const that = this;
                window.onresize = function temp() {
                    let widowHeight = document.documentElement.clientHeight - 275;
                    let h = document.getElementById('searchBox').clientHeight;
                    that.tableHeight = widowHeight - h;
                };
            }, 1);
        },
        resetLabelWidth() {
            if (getLocal('language') === 'zh-CN') {
                this.labelW = 100 + 'px';
            } else {
                this.labelW = 120 + 'px';
            }
        },
        showMore() {
            this.isShowMore = !this.isShowMore;
        },
        //清除导入子组件值
        handleClose() {
            this.$refs.importExport.clearFileAction();
            this.importDialogVisibleView = false;
        },
        /*excel 预览 数据上传事件*/
        async excelAction() {
            let data = await ImportBlacklist(
                this.excelListView,
            );
            if (data.error_code === '0') {
                this.$message.success(this.$t('message.Lang_Operate_Success'));
                this.$refs.importExport.clearFileAction();
                this.getBlacklistList();
                this.importDialogVisibleView = false;
            } else {
                this.$message.error(this.$t('message.Lang_Operate'));
            }
        },
        excelChildChange(data) {
            this.$excelChildChange(data).then(res => {
                console.log('预览数据', res);
                if (res.length == 0) {
                    this.$refs.importExport.clearFileAction();
                    return;
                }
                this.excelListView = res;
                this.importDialogVisibleView = true;
            });
        },
        async initData() {
            try {
                this.getBlacklistList();
            } catch (err) {
                console.log(err);
            }
        },
        exportData(){
            this.downloadPostTem(ExportPreviewCompensation,null,{ 
                Name: this.ruleForm.Name,
                VATNo: this.ruleForm.VATNo,
                PageIndex: 0,
                PageSize: 0
            });
        },
        // 获取黑名单列表
        async getBlacklistList() {
            this.isLoading = true;
            this.tableData = [];
            try {
                let data = await GetBlacklistList(
                    this.ruleForm.Name,
                    this.ruleForm.VATNo,
                    getLocal('language'),
                    this.offset,
                    this.limit
                );
                if (data.error_code === '0') {
                    this.isLoading = false;
                    this.count = data.data.TotalCount;
                    this.tableData = data.data.returnList;
                } else {
                    this.isLoading = false;
                }
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },
        // 更改每页显示数据条数
        handleSizeChange(val) {
            this.limit = val;
            this.currentPage = 1;
            this.offset = 1;
            this.getBlacklistList();
        },
        // 更改当前页数
        handleCurrentChange(val) {
            this.currentPage = val;
            this.offset = val;
            this.getBlacklistList();
        },
        // 搜索
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.offset = 1;
                    this.currentPage = 1;
                    this.getBlacklistList();
                } else {
                    return false;
                }
            });
        },
        // 重置
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.offset = 0;
            this.currentPage = 1;
            this.getBlacklistList();
        },
        //删除黑名单
        async delRole(Id) {
            try {
                this.$confirm(this.$t('message.ConfirmDelete'), this.$t('message.Tips'), {
                    confirmButtonText: ' ',
                    cancelButtonText: ' ',
                    confirmButtonClass: 'icon iconfont icon-gou-wukuang',
                    cancelButtonClass: 'icon iconfont icon-guanbi-wukuang',
                    type: 'warning'
                })
                    .then(async () => {
                        let data = await DelBlacklist(Id, getLocal('language'));
                        if (data.error_code === '0') {
                            this.$message.success(this.$t('message.DeleteSuccessful'));
                            this.offset = 1;
                            this.currentPage = 1;
                            this.getBlacklistList();
                        } else {
                            this.$message.error(this.$t('message.DeleteFailed'));
                        }
                    })
                    .catch(() => {});
            } catch (error) {
                console.log(error);
            }
        },
        //删除
        handleDelete(Id) {
            this.delRole(Id);
        }
    }
};
</script>

<style scoped></style>
